(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veyra-stock-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veyra-ship-date')) {
    customElements.define(
      'veyra-ship-date',
      class extends HTMLElement {
        connectedCallback() {
          const date = new Date();
          date.setDate(date.getDate() + 1);
          this.textContent = date.toLocaleDateString(document.documentElement.lang || 'en', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
